import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: 800,
    backgroundColor: theme.palette.background.paper,
  },
  listItemHeader: {
    maxWidth: 400,
    width: '100%',
    marginRight: 40,
  },
  listContentContainer: {
    display: 'flex',
    width: '100%',
    marginRight: 'auto',
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  },
  listIcon: {
    marginLeft: 40,
  },
  arrowIcon: {
    width: theme.spacing(4),
    height: theme.spacing(4),
  },
}));
